export default {
  title: 'Program lojalnościowy',
};
